import { VARIABLE_CONSTANTS, VariableCrudManagerService } from "@wms/variables";
import { ServiceFactoryService } from "@wms/services";
import { forEach, includes, reject } from "lodash-es";

export class WebserviceVariableCreation {
    constructor(private serviceFactory: ServiceFactoryService, private varManagerService: VariableCrudManagerService) {
    }
     /*
     * gets the data-services required for selecting live-source for a live variable
     * called on switching to a new/created live variable
     */
    getVariableDependencies() {
        this.initApiTypeOptions();
        /*get the list of services available and append the options for service property*/
        (this.serviceFactory.getServicesWithType() as Promise<any>).then((services) => {
            services = reject(services, (service) => !includes(VARIABLE_CONSTANTS.WEB_SERVICE_VARIABLE_SERVICES, service.type));
            services.sort((prevItem: any, currentItem: any) => prevItem.name.localeCompare(currentItem.name));

            /*push the services in the options list for the respective property selectbox*/
            this.varManagerService.initVariableObj.propertyObj.service.options = {};
            forEach(services, (serviceObj) => {
                this.varManagerService.initVariableObj.propertyObj.service.options[serviceObj.name] = {
                    name: serviceObj.name,
                    type: serviceObj.type.toLowerCase() === 'openapiservice' ? 'Imported APIs' : serviceObj.type
                };
            });
        });
    }

    getApiOptions() {
        return {
            'Database': [
                {
                    'id': 'entity',
                    'name': 'Generated API for Entity'
                },
                {
                    'id': 'query',
                    'name': 'Query'
                },
                {
                    'id': 'procedure',
                    'name': 'Procedure'
                }
            ],
            'Web Service': [
                {
                    id: VARIABLE_CONSTANTS.SERVICE_TYPE_REST,
                    'name': 'REST Service'
                },
                {
                    id: VARIABLE_CONSTANTS.SERVICE_TYPE_SOAP,
                    'name': 'SOAP Service'
                },
                {
                    id: VARIABLE_CONSTANTS.SERVICE_TYPE_WEBSOCKET,
                    'name': 'WebSocket Service'
                }
            ],
            'Java Service': [{
                id: VARIABLE_CONSTANTS.SERVICE_TYPE_JAVA,
                name: 'Java Service'
            }],
            'Security Service': [{
                id: VARIABLE_CONSTANTS.SERVICE_TYPE_SECURITY,
                name: 'Security Service'
            }]
        };
    }

    initApiTypeOptions() {
        let options = this.getApiOptions(),
            apiTypeOptions: any = {};
        forEach(options, (options, key) => {
            options.forEach((option) => {
                apiTypeOptions[option.id] = {name: option.name, type: key, id: option.id};
            }); 
        });
        this.varManagerService.initVariableObj.propertyObj.apitype.options = apiTypeOptions;
    }


    onApiTypeChange() {
        let apiTypeObj = this.varManagerService.initVariableObj.values.apitype,
            apiType,
            apiOptions = this.getApiOptions(),
            serviceType,
            operationType;
        if (!apiTypeObj) {
            return;
        }
        apiType = apiTypeObj.id;
        switch (apiType) {
        case apiOptions.Database[0].id:
        case apiOptions.Database[1].id:
        case apiOptions.Database[2].id:
            serviceType = VARIABLE_CONSTANTS.SERVICE_TYPE_DATA;
            operationType = apiType;
            break;
        default:
            serviceType = apiType;
            break;
        }
        this.varManagerService.selectedVariableCategory = 'wm.ServiceVariable';
        this.varManagerService.createVariable(this.varManagerService.selectedVariableCategory, {
            _serviceType: serviceType,
            _operationType: operationType
        });
    }

    __onPropertyChange(propName: any) {
        switch (propName) {
        case 'apitype':
            this.onApiTypeChange();
            break;
        case 'service':
            this.varManagerService.showPrimaryProps = true;
            let selectedService = this.varManagerService.initVariableObj.values.service,
                serviceType = (this.serviceFactory.getServiceObjectByName(selectedService) as any).type;
            if (serviceType === VARIABLE_CONSTANTS.SERVICE_TYPE_WEBSOCKET) {
                this.varManagerService.selectedVariableCategory = 'wm.WebSocketVariable';
                this.varManagerService.createVariable(this.varManagerService.selectedVariableCategory, {
                    service: selectedService,
                    operation: 'invoke'
                });
            } else {
                this.varManagerService.selectedVariableCategory = 'wm.ServiceVariable';
                this.varManagerService.createVariable(this.varManagerService.selectedVariableCategory, {
                    service: selectedService,
                    operation: serviceType === VARIABLE_CONSTANTS.SERVICE_TYPE_REST ? 'invoke' : undefined
                });
            }
            break;
        }
    }
}